import { useEffect, useMemo, useState } from 'react';
import { Role } from 'api/models';
import { useNoDataRender } from '../scheduler-config/no-data-renderer';
import { getDemandSorter } from '../sorters';
import { SchedulerReference } from '../types';

interface Props {
  roles: Role[];
  schedulerRef: SchedulerReference;
  onReset: () => void;
  searchText: string;
  canApplyFilter: boolean;
}
export const useDemandViewFilter = ({
  roles,
  schedulerRef,
  onReset,
  searchText,
  canApplyFilter,
}: Props): void => {
  const matchedRoleIds = useMemo(
    () =>
      roles
        .filter(({ roleName }) =>
          roleName.toLowerCase().includes(searchText.toLowerCase()),
        )
        .map(({ roleId }) => roleId),
    [roles, searchText],
  );
  const [noData, setNoData] = useState(false);

  useNoDataRender({
    schedulerRef,
    noData,
    onReset,
  });

  useEffect(() => {
    if (!canApplyFilter) {
      return;
    }
    schedulerRef.current.instance.resourceStore.filter({
      filters: {
        id: 'demand-view-filter',
        filterBy: (resource) => {
          const roleId = resource.get('roleId');

          return matchedRoleIds.includes(roleId);
        },
      },
      reapplyFilterOnAdd: true,
      reapplyFilterOnUpdate: true,
    });
    schedulerRef.current.instance.resourceStore.sort(getDemandSorter());
    setNoData(schedulerRef.current?.instance.resourceStore.allCount === 0);
  }, [schedulerRef, canApplyFilter, matchedRoleIds]);
};
